type Factory<T> = () => T;

export class ParcelDependencyContainer {
    private factories = new Map<string, Factory<any>>();

    register<T>(key: string, factory: Factory<T>): void {
        this.factories.set(key, factory);
    }

    resolve<T>(key: string): T {
        const factory = this.factories.get(key);
        if (!factory) {
            throw new Error(`Factory not found for: ${key}`);
        }
        return factory();
    }
}